module.exports = __webpack_public_path__ + "static/img/luchi.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/luchi.jpg
// module id = BefJ
// module chunks = 0